import CheckoutSummary from './CheckoutSummary';
import { cartUpdatingSel } from 'src/store/modules/cart';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => {
  return {
    updating: cartUpdatingSel(state)
  };
};

export default connect(mapStateToProps, null)(CheckoutSummary);
